"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLACEHOLDERS_COPY = void 0;
exports.PLACEHOLDERS_COPY = {
    ADD_ADDITIONAL_NOTES: '+ Add additional notes',
    ADD_A_BUSINESS_DEFINITION: '+ Add a business definition',
    ADD_A_COMMENT: 'Add a comment...',
    ADD_A_DESCRIPTION: '+ Add a description',
    ADD_A_TASK: 'Add a task',
    ADD_DESCRIPTION: 'Add a description...',
    ADD_HELPTEXT: '+ Add help text',
    ADD_OWNER: 'Add Owner',
    APP_DESCRIPTION: 'Describe this application, what it does, and how it fits into your tech stack.',
    APP_LABEL: 'Sandbox',
    APP_NAME: 'App Name',
    APP_USER: 'app@company.com',
    COMPANY_NAME: 'Company Name',
    CONFIRM_PASSWORD: 'Confirm Password',
    CURRENT_PASSWORD: 'Current Password',
    EMAIL: 'email@company.com',
    EMAIL_USER_SAMPLE: 'email@company.com',
    ENTER_YOUR_API_KEY: 'Enter your Api Key',
    ENTER_YOUR_USERNAME: 'Enter your username',
    FILE_NAME: 'File Name',
    FILTER_BY: (label) => `Filter by ${label !== null && label !== void 0 ? label : ''}`,
    FILTER_BY_OWNER: 'Filter by Owner',
    FILTER_BY_STAKEHOLDERS: 'Filter by Stakeholders',
    FILTER_BY_TAG: 'Filter by Tag',
    FIRST_NAME: 'First Name',
    FROM_ORGANIZATION: 'From Organization',
    LAST_NAME: 'Last Name',
    LINK_TITLE: 'Link Title (Optional)',
    LINK_URL: 'Link Url',
    NAME_YOUR_INITIATIVE: 'Name your initiative',
    NAME_YOUR_MONITOR: 'Name Your Monitor',
    NAME_YOUR_TASK: 'Name your task',
    NAME_YOUR_VIEW: 'Name Your View',
    NEW_PASSWORD: 'New Password',
    OTHER_PLEASE_SPECIFY: 'Other (please specify)',
    PASSWORD: 'Password',
    PASTE_FIELD_NAMES: 'Paste (CTRL+V) up to 100 field API names (case sensitive), comma or newline delimited',
    PASTE_YOUR_URL: 'Paste your url here...',
    SEARCH_BY_TITLE: 'Search By Title',
    SEARCH_DATA_DICTIONARY: 'Search for specific entities, or all of one type',
    SEARCH_DISPLAY_NAMES: 'Search Display Names',
    SEARCH_INITIATIVES: 'Search Initiatives',
    SEARCH_JIRA_ISSUES: 'Search for your Jira Issue title or number',
    SEARCH_MONITORS: 'Search Monitors',
    SEARCH_TAGS: 'Search Tags',
    SEARCH_TASKS: 'Search Tasks',
    SELECT_AN_APPLICATION: 'Select an application',
    SELECT_APP_GROUP: 'Select App Group',
    SELECT_INTEGRATIONS: 'Select Integrations',
    SELECT_PROJECT: 'Select Project',
    STAKEHOLDER_EMAIL: 'finance@company.com',
    STAKEHOLDER_NAME: 'Finance',
    TAG_DESCRIPTION: 'Tag Description',
    TAG_NAME: 'Tag Name',
    TAG_OWNERS: 'Select Tag Owners',
    TO_ORGANIZATION: 'To Organization'
};
//# sourceMappingURL=COPY.js.map